export default {
  twoFactorAuthenticationEnforcement: true,
  isTestMode: false
}
